import { useEffect } from 'react';

export interface WorksurfaceTitleProps {
  title: string;
  context?: string;
}

/**
 * A declarative component to update the DashboardShell's top bar title and context.
 * It doesn't render anything itself, but uses an effect to signal the shell.
 */
export function WorksurfaceTitle({ title, context }: WorksurfaceTitleProps) {
  useEffect(() => {
    // We use a custom event to communicate with the DashboardShell/TopBar
    // since we don't have a shared context for title overrides yet.
    const event = new CustomEvent('silk-worksurface-title-change', {
      detail: { title, context }
    });
    window.dispatchEvent(event);
    
    return () => {
      // Optional: reset or handle cleanup if needed
    };
  }, [title, context]);

  return null;
}
